module.exports = __webpack_public_path__ + "static/img/1_12_1.7db44680.jpg";